/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { InlineVideo } from 'components/inline-video'
import s from './BlogVideo.module.css'

export default function BlogVideo({ url, description }) {
	return (
		<section className={s.videoContainer}>
			<InlineVideo
				url={url}
				description={description}
				gradientPosition={false}
			/>
		</section>
	)
}
